<template>
    <!-- 升学途径 其他升学途径 -->
    <!--  (港澳招生)-->
    <div class="gangao_recruitstudents studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">招生方式有哪些？</h6>
            <div class="main_box">
                <p>目前，在内地招生的21所港澳高校有两种招生方式：一种是香港中文大学和香港城市大学2所高校采用的统招方式，另一种是香港大学等13所香港高校和澳门大学等6所澳门高校采用的独立招生方式。</p>
                <p>香港中文大学、香港城市大学采用内地高校统一招生方式，即由省招生办统一公布招生计划、统一安排考生填报志愿、统一实行远程网上录取。两所高校参加提前批次录取。考生在填报这两所高校中的任何一所时，还可填报其他本科第一批次的内地高校，即使在提前批次未被录取，仍有机会在本科第一批次录取时进入其他的内地高校。</p>
                <p>香港大学、香港科技大学、香港理工大学、香港浸会大学、岭南大学、香港教育大学、香港树仁大学、香港公开大学、香港演艺学院、珠海学院、恒生管理学院、东华学院和香港高等教育科技学院等13所高校采用独立招生方式，招生计划不分到省。考生须参加高考，并按照港校的要求报名，参加学校单独组织的笔试和面试，由学校根据考生高考成绩和其他要求录取新生。凡被香港13所独立招生院校录取的考生，不再参加内地高校远程网上统一录取。</p>
                <p>澳门大学、澳门科技大学、澳门理工学院、旅游学院、澳门镜湖护理学院和澳门城市大学等6所高校也采用独立招生方式，招生计划不分省，全国统一招生。高中毕业或相当于高中毕业文化程度的应届高考生均可报考以上高校，考生必须参加高考。各校具体招生情况可登录澳门高等教育辅助办公室网站查询。</p>
            </div>    
        </div>
        <div class="main">
            <h6 class="main_title">港澳高校报考指南</h6>
            <div class="main_box">
                <div class="ques">
                    <p class="big_title">（一）内地考生报考港澳高校需要知道什么？</p>
                    <p class="small_title">招生地区</p>
                    <p>自2011年起，有关港澳高校可在全国31个省、直辖市、自治区招收自费生。</p>
                    <p class="small_title">报考资格</p>
                    <p>内地考生必须符合中国政府有关赴港澳就读的规定；必须参加当年普通高等学校全国统一招生考试。</p>
                    <p class="small_title">申请材料</p>
                    <p>报名表、户口簿、学历证明原件及复印件、照片等。</p>
                    <p class="small_title">分数线</p>
                    <p>高考分数须至少达到或超过生源所在地的第二批本科录取控制分数线。各高等院校参照申请者内地高考成绩择优录取。（香港中文大学、香港城市大学参加高考统一录取，在提前批次。）</p>
                    <p class="small_title">费用</p>
                    <p>香港高校每年费用16-18万港币，澳门高校每年费用约7.2万人民币。具体各校略有不同，详细情况请参照所申请院校官网。</p>
                    <p class="small_title">奖助学金</p>
                    <p>各高校为成绩优异的考生提供丰厚的奖学金。值得注意的是能拿到全额奖学金的是很小一部分考生，绝大多数考生需要自费。自费生入读后虽然可申请各类奖助学金，但竞争非常激烈。</p>
                    <p class="small_title">签证</p>
                    <p>一般情况下，申请学生签证的时间为4-6周。内地同学获录取后，应立即着手办理申请香港、澳门特区入境签证手续。学校会在发出录取通知书的同时，把香港、澳门特区入境签证申请表格一同寄给考生。</p>
                </div>
                <div class="ques">
                    <p class="big_title">（二）考生申请香港高校从哪些渠道获取信息？</p>
                    <p>在高校招生录取季，学生和家长们还需特别警惕虚假学校。香港也曾出现过“野鸡大学”。如2015年被曝光的“香港苏文大学”，在其网站上以合成照片介绍校园，甚至依靠网络购物平台兜售学历证书。香港特区政府教育局明确表示，“香港苏文大学”并非根据当地《教育条例》注册或临时注册的学校。</p>
                    <p>怎么避免碰上“野鸡大学”呢?香港特区政府教育局在其官网上罗列了香港21所可颁授学位的高等教育院校名称，并提供各院校网站入口。此外，根据教育局官网资料介绍，“香港升学”网站可为非香港本地学生赴港升学提供较全面的资讯，不仅可查询院校、课程等信息，还能为学生在港生活、就业等给予提示。</p>
                </div>
                <div class="ques">
                    <p class="big_title">（三）考生能被港校和内地高校同时录取吗？</p>
                    <p>不会存在同时录取的现象。</p>
                    <p>香港大学、香港科技大学、香港理工大学、香港浸会大学、岭南大学、香港教育学院、香港树仁大学、香港公开大学、香港演艺学院、珠海学院等高校每年参考考生高考成绩，在内地自主招生，于7月7日前结束录取，被上述香港高校录取的学生，内地高校不再予以录取。</p>
                    <p>香港中文大学、香港城市大学列入提前录取批次。这意味着考生在填报这两个高校中的任何一所高校同时，也可填报其他本科第一批次的内地重点高校，即便在提前批次未被录取，仍有机会在本科第一批次录取时进入其他的内地重点高校，风险大大降低。</p>
                </div>
                <div class="ques">
                    <p  class="big_title">（四）考生能被澳门高校和内地高校同时录取吗？</p>
                    <p>可以。澳门高校属于单独招生，如果考生同时被澳门高校与内地高校录取，考生可自行决定在澳门还是在内地就读。</p>
                </div>
                <div class="ques">
                    <p  class="big_title">（五）港澳高校是否有奖学金？</p>
                    <p>香港高等院校奖学金情况</p>
                    <p>香港高等院校奖学金设置情况，以香港大学和香港中文大学为例。</p>
                    <p>香港大学设立了丰厚的入学奖学金，奖励录取名单中部分成绩特别突出且综合素质优秀的内地学生，全额奖学金将涵盖学生在港大就读期间全部的学费及基本生活费。奖学金无需单独申请，获得港大录取的学生将自动被纳入奖学金考虑之列。此外，香港大学还设有众多不同类别的奖学金及奖项供所有港大在校本科生申请。</p>
                    <p>香港中文大学奖学金有：全额奖学金、全免学费奖学金及本科入学奖学金三种。“全额奖学金”学生将获发相等于攻读四年本科课程的学费，以及每年45000港元住宿及生活津贴；“全免学费奖学金”学生可获发相等于攻读四年本科课程的学费；“本科入学奖学金”学生可获发相等于攻读四年本科课程的一半学费及一万港元生活津贴，四年共三十万港元。</p>
                    <p>香港高校奖学金的设置详情可向各校咨询。</p>
                    <p>澳门高等院校均设有奖学金</p>
                    <p>澳门高等院校均设有奖学金，如澳门大学有全免奖学金和澳门基金会奖学金。</p>
                    <p>澳大每年特设“澳门大学全免奖学金”，获奖学金的考生除可获豁免第一学年学费及住宿式书院费用外，并可获荣誉学院优先录取资格。该奖学金是可以延续的，学生必须于就读期间每学年的平均绩点达指定要求，即可继续获得奖学金，获颁年期最长为四学年。</p>
                    <p>“澳门基金会奖学金”颁发给学业成绩优秀的内地学生每年澳门币3万元。获奖学金的新生如每学年的平均绩点达指定分数要求，可于第二、三、四学年继续获得奖学金，最长四学年（每名学生4学年可获奖学金共澳门币12万元）。</p>
                    <p>此外，学生入读后成绩优秀的本科学生有机会获颁发由企业及个人捐赠的奖学金。</p>
                    <p>澳门高校奖学金的设置详情可向各校咨询。</p>
                </div>
            </div>
        </div>
        <div class="main universities">
            <h6 class="main_title">香港高校内地招生介绍
                <span>*由于各方面条件不断调整变化，请考生以各省考试院公布的最新消息为主</span>
            </h6>
            <table>
                <tr>
                    <th>招生院校</th>
                    <th>特点</th>
                    <th>同等院校</th>
                    <th>录取要求</th>
                    <th>所需费用</th>
                    <th>官方网址</th>
                </tr>
                <tr v-for="(item,index) in universities_HK" :key="index">
                    <td>{{item.school}}</td>
                    <td><p>{{item.characteristics}}</p></td>
                    <td class="range"><p>{{item.similar}}</p></td>
                    <td class="require"><p>{{item.require}}</p></td>
                    <td><p>{{item.detail}}</p></td>
                    <td><a :href="item.url" target="_blank">{{item.school}}</a></td>
                </tr>
            </table>
        </div>
        <div class="main universities">
            <h6 class="main_title">澳门高校内地招生介绍
                <span>*由于各方面条件不断调整变化，请考生以各省考试院公布的最新消息为主</span>
            </h6>
            <table>
                <tr>
                    <th>招生院校</th>
                    <th>特点</th>
                    <th>同等院校</th>
                    <th>录取要求</th>
                    <th>所需费用</th>
                    <th>官方网址</th>
                </tr>
                <tr v-for="(item,index) in universities_Macao" :key="index">
                    <td>{{item.school}}</td>
                    <td><p>{{item.characteristics}}</p></td>
                    <td class="range"><p>{{item.similar}}</p></td>
                    <td class="require"><p>{{item.require}}</p></td>
                    <td><p>{{item.detail}}</p></td>
                    <td><a>{{item.school}}</a></td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>

export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {
            // 香港
            universities_HK: [
                {"school":"香港中文大学","characteristics":"两文三语，中外兼重","similar":"清华、北大","require":"考生统考成绩应达到本科一批高校录取控制分数线以上，单科成绩原则上应达到及格水平。","detail":"香港中文大学非本地生的学费为每年145,000港元。校园宿舍住宿费约10,000港元，其他杂费、生活费每年约需30,000港元。","url":"http://admission.cuhk.edu.hk/sc/mainland/requirements.html"},
                {"school":"香港城市大学","characteristics":"年轻、进取","similar":"C9院校","require":"进该校官方网站查看","detail":"每学年港币12万元。","url":"http://www.cityu.edu.hk/mainland/"},
                {"school":"香港大学","characteristics":"香港第一学府","similar":"清华、北大","require":"港大会优先考虑以下因素：申请人的高考总成绩、申请人的高考英语成绩、申请人在面试中的综合表现。","detail":"2017至2018年非本地学生在港大修读首个本科学位课程的学费为每年港币十四万六千元，住宿费及生活费约为每年港币四万元。","url":"https://aal.hku.hk/admissions/mainland/"},
                {"school":"香港科技大学","characteristics":"后来居上，工商结合","similar":"清华、北大","require":"以择优录取方式招生，并以国家统一高考的成绩作初步筛选。高考成绩公布后，将邀请部分同学参加面试，并根据同学面试表现、高考成绩、综合素质等再行择优录取。","detail":"进该校官方网站查看","url":"http://www51.polyu.edu.hk/eprospectus/ug/jee"},
                {"school":"香港浸会大学","characteristics":"传媒至尊","similar":"C9院校","require":"以国家统一高考成绩及入学面试表现综合评估，择优录取。","detail":"2017/18学年全年学费为港币120,000元。","url":"http://admissions.hkbu.edu.hk/en/mainland-jee.html"},
                {"school":"岭南大学","characteristics":"博雅教育","similar":"央财、华东师大","require":"申请人须于应届内地高考取得良好成绩，并具备良好的英语水平。","detail":"每年学习及生活费用合共约港币16至18万元。","url":"https://www.ln.edu.hk/admissions/ug/mainland/news"},
                {"school":"香港教育大学","characteristics":"师范学校","similar":"央财、华东师大","require":"详细入学条件请参考网页：点击查看。","detail":"学费根据修读的课程有所不同。每年学费从港币78,000到120,000不等。详情请参考网页：点击查看。","url":"http://admission.cuhk.edu.hk/sc/mainland/requirements.html"},
                {"school":"香港树仁大学","characteristics":"首间私立大学","similar":"国内一本院校","require":"申请入学的内地学生须完成或即将完成高中三年级学业，并须于内地高考取得良好成绩(所属省市第二批本科分数线或以上)。","detail":"2017-18年度，所有新生学费为每年港币6万8千元元，每年宿费约为港币2万元，估计每年学习及生活费用合共约港币12至14万元。","url":"https://www.hksyu.edu/en/"},
                {"school":"香港公开大学","characteristics":"公立不公费","similar":"国内一本院校","require":"1.参加2017年全国普通高等学校统一招生考试，成绩须达到二本线或以上的应届高中毕业生；2.高考英语成绩须达到本校要求；3.通过本校面试及英语笔试（如适用者）。有关课程的面试及英语笔试，一般都会安排于六月底，在深圳进行。","detail":"进该校官方网站查看","url":"http://www.ouhk.edu.hk/wcsprd/Satellite?pagename=OUHK/tcSingPage&lang=chi"},
                {"school":"香港演艺学院","characteristics":"明星辈出","similar":"国内一本院校","require":"进该校官方网站查看","detail":"进该校官方网站查看","url":"https://www.hkapa.edu/"},
                {"school":"珠海学院","characteristics":"历史悠久","similar":"国内一本院校","require":"申请入学的内地学生须完成或即将完成高中三年级学业，所属省市报读第二批本科分数线或以上。","detail":"学费：一、二年级：港币$69,000；","url":"https://www.chuhai.edu.hk/zh-hans"}
            ],
            // 澳门
            universities_Macao: [
                {"school":"澳门大学","characteristics":"综合性大学","similar":"北邮、北京交通大学、重庆大学","require":"本校将根据申请人2017年高考之成绩（达到所属省市本科第一批录取分数綫以上）、英语成绩及各课程之收生名额，择优录取。","detail":"进该校官方网站查看","url":"澳门大学"},
                {"school":"澳门理工学院","characteristics":"和澳门大学同同源","similar":"国内一本院校","require":"学院主要参考考生在普通高考的总成绩作录取。考生高考分数须达到或超过所属省/市的第一批录取分数线，单科英语成绩只作参考用。","detail":"学费：每年澳门币24,800元（约人民币22,000元）","url":"澳门理工学院"},
                {"school":"澳门科技大学","characteristics":"留学生比例非常高","similar":"国内一本院校","require":"1.学士学位课程：参考应届高考成绩达省划本科第一、二批次以上，择优录取；2.艺术学-艺术设计学士学位课程：参考应届省级美术类专业联考和艺术类文化课高考成绩同时达省划本科第一、二批次以上，择优录取；3.体艺特长生：卷面成绩达到上述要求且通过面试签署特长生协议者，根据体艺表现水平优先录取或优先获颁奖学金。","detail":"进该校官方网站查看","url":"澳门科技大学"},
                {"school":"旅游学院","characteristics":"首个获世界旅游组织旅游教育素质认证","similar":"国内一本院校","require":"参加应届全国统一高考，成绩以省 / 自治区 / 直辖市本科一线录取分数线以上为参考。","detail":"进该校官方网站查看","url":"旅游学院"},
                {"school":"澳门镜湖护理学院","characteristics":"由创办于一九二三年的镜湖护士助产学校发展而成","similar":"国内二本院校","require":"进该校官方网站查看","detail":"进该校官方网站查看","url":"澳门镜湖护理学院"},
                {"school":"澳门城市大学","characteristics":"私立","similar":"国内二本院校","require":"高考成绩须过考试所在省市公布的本科第二批次录取分数线（二本或本科线），一本线及以上者优先录取。","detail":"进该校官方网站查看","url":"澳门城市大学"},
            ]
        }
    },
    methods: {
        goUniversity(id) {
            var id = id;
            let {href}=this.$router.resolve({
                path: '/yuanxiaoxiangqing',
                name: 'yuanxiaoxiangqing',
                query: {
                    id: id,
                }
            })
            window.open(href, '_blank');
        }
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    .gangao_recruitstudents {
        .ques {
            margin-bottom: 20px;
            .big_title {
                font-weight: 600;
                font-size: 16px;
                color: #333;
            }
            .small_title {
                font-weight: 600;
                font-size: 14px;
                color: #333;
            }

        }
        .universities {
            table {
                border: 1px solid #eaeaea;
                font-size: 14px;
                text-align: center;
                tr {
                    th {
                        line-height: 50px;
                        text-align: center;
                        border: 1px solid #60badf;
                        background-color: #60badf;
                        color: #fff;
                        &:nth-child(1) {
                            width: 15%; 
                        }
                        &:nth-child(2) {
                            width: 10%; 
                        }
                        &:nth-child(3) {
                            width: 10%; 
                        }
                        &:nth-child(4) {
                            width: 25%; 
                        }
                        &:nth-child(5) {
                            width: 25%; 
                        }
                        &:nth-child(6) {
                            width: 15%; 
                        }
                    }
                }
                tr {
                    &:nth-child(odd) {
                        background-color: #e6f8ff;
                    }
                    td {
                        border: 1px solid #eaeaea;
                        line-height: 40px;
                        align-items: center;
                        &:first-child {
                            cursor: pointer;
                        }
                        p {
                            line-height: 24px;
                        }
                        a {
                            color: #2c8ffc;
                        }
                    }
                    .range {
                        padding: 5px 10px;
                        text-align: left;
                    }
                    .remarks {
                        padding: 5px 10px;
                        text-align: left;
                    }
                }
            }
        }
    }
</style>